import { api } from '../client/axiosClient';
import { ProgramDto, ProgramVersionDto, ProgramTypeDto } from '../types/dtos/program';
import { BaseService } from './base.service';
import { CustomResponseEntity, PaginationParams } from '../types/common';


const DATASOURCE_URI = '/api';
const VERSION = 'v1';

/**
 * Fetch programs for an organization.
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @deprecated Use createProgramService() instead
 */
export const fetchPrograms = async (_organizationId: string): Promise<ProgramDto[]> => {
  console.log('fetchPrograms - start', _organizationId, Date.now());
  // axios interceptor already unwraps response.data, so response is the CustomResponseEntity
  const response = await api.get<CustomResponseEntity<ProgramDto[]>>(`${DATASOURCE_URI}/${VERSION}/programs`);
  console.log('fetchPrograms - end', _organizationId, Date.now());
  return response.data || [];
};

/**
 * Fetch program versions.
 * @deprecated Use ProgramVersionService instead
 */
export const fetchProgramVersions = async (): Promise<ProgramVersionDto[]> => {
  const res = await api.get<ProgramVersionDto[]>(`/api/v1/program-versions`);
    return res;
};

/**
 * ProgramService handles CRUD operations for programs.
 *
 * URL Pattern: /api/v1/programs
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * VAL-PRG-001: Program List with X-Organization-Id Header
 *
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 */
export class ProgramService extends BaseService<ProgramDto> {
  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   */
  constructor(_organizationId?: string) {
    super('/api/v1/programs');
  }

  findAll(params?: PaginationParams & { isActive?: boolean }): Promise<CustomResponseEntity<ProgramDto[]>> {
    return super.findAll(params);
  }
}

/**
 * Factory function to create a ProgramService instance
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 */
export const createProgramService = (_organizationId?: string) => new ProgramService(_organizationId);

/**
 * Fetch available program types for the organization.
 */
export const fetchProgramTypes = async (): Promise<ProgramTypeDto[]> => {
  const response = await api.get<CustomResponseEntity<ProgramTypeDto[]>>(
    `${DATASOURCE_URI}/${VERSION}/programs/types`
  );
  return response.data || [];
};